import NetworkService from "./NetworkService";

export default class AdminDashboardService extends NetworkService {
  constructor() {
    super();
    this.base = "api/admin/dashboard";
  }

  bigNumbers() {
    return this.get(`${this.base}/big-numbers`);
  }
  users() {
    return this.get(`${this.base}/users`);
  }
  appointments() {
    return this.get(`${this.base}/appointments`);
  }
  kpis() {
    return this.get(`${this.base}/kpis`);
  }
  financial() {
    return this.get(`${this.base}/financial`);
  }
  actionCenter() {
    return this.get(`${this.base}/action-center`);
  }
  // Totais de psis por segmento (pills) — uma chamada só
  psyCounts(filters) {
    return this.get(`${this.base}/psy-counts`, filters);
  }
}
